export const Download = async (downloadUrl: string) => {
  const a = document.createElement('a');
  a.href = downloadUrl;
  a.click();
};
export default Download;
